// Service & Repair (booking) job actions — same endpoints and params as the Android technician app
// (api/v3/pro/bookings/*, payment/*). Every call resolves to { ok, body, message, activeRecord } and never throws;
// apiCall shows the global loader.
import { apiCall } from "./apiCall";

// Booking statuses (Laravel app/Models/Interfaces/Booking/Definition.php)
export const BOOKING_STATUS = {
  PENDING: 0, ACCEPTED: 1, EN_ROUTE: 2, ARRIVED: 3, DIAGNOSIS_STARTED: 4, DIAGNOSIS_COMPLETED: 5,
  QUOTE_READY: 6, STARTED: 7, SUSPENDED: 8, COMPLETED: 9, CANCELLED: 10, REJECTED_BY_TECHNICIAN: 11,
  NEW_SYSTEM: 13, CONSUMER_DIAGNOSIS_DECLINE: 14,
};

export const bookingActionsApi = {
  // the booking detail (company_consumer_id + consumer), as the S&R Job Details page loads it
  show: (bookingId) => apiCall("post", "bookings/show", { booking_id: bookingId }),
  // POST bookings/status { booking_id, status } (BookingStatusUpdateRequest; reason only for status 8)
  updateStatus: (bookingId, status) => apiCall("post", "bookings/status", { booking_id: bookingId, status: String(status) }),
  accept: (bookingId) => bookingActionsApi.updateStatus(bookingId, BOOKING_STATUS.ACCEPTED),
  reject: (bookingId) => bookingActionsApi.updateStatus(bookingId, BOOKING_STATUS.REJECTED_BY_TECHNICIAN),
  enRoute: (bookingId) => bookingActionsApi.updateStatus(bookingId, BOOKING_STATUS.EN_ROUTE),
  cancel: (bookingId) => bookingActionsApi.updateStatus(bookingId, BOOKING_STATUS.CANCELLED),
  begin: (bookingId) => bookingActionsApi.updateStatus(bookingId, BOOKING_STATUS.STARTED),

  // POST bookings/arrived { booking_id } (BookingArrivedRequest)
  arrived: (bookingId) => apiCall("post", "bookings/arrived", { booking_id: bookingId }),

  // Job History (Android CompletedJobsFragment with a booking): POST old/bookings { booking_id, limit, page }
  // -> the consumer's completed bookings (BookingResource list, paginated)
  oldBookings: (bookingId, page = 1, limit = 10) => apiCall("post", "old/bookings", { booking_id: bookingId, limit, page }),

  // POST bookings/send-proposal { booking_id, email }
  sendProposal: (bookingId, email) => apiCall("post", "bookings/send-proposal", { booking_id: bookingId, email }),

  // Payment acknowledgement (Android PaymentInfoDialog)
  // GET payment/booking/data/{booking} -> { payment_type, amount, amount_prefix, event, check?, institution_name?, description? }
  paymentData: (bookingId) => apiCall("get", `payment/booking/data/${bookingId}`, { id: bookingId, model: "booking" }),
  // POST payment/booking/decision/{booking} { decision: yes|no }
  paymentDecision: (bookingId, decision) => apiCall("post", `payment/booking/decision/${bookingId}`, { decision }),
  // POST payment/atwood { id, model: booking, revised_amount, event } (PaymentAtwoodRequest; event must be the installation invoice type)
  atwood: (bookingId, revisedAmount, event) => apiCall("post", "payment/atwood", {
    id: bookingId, model: "booking", revised_amount: revisedAmount, event,
  }),
};
